module.exports = __webpack_public_path__ + "static/media/LOADER_05.4080789a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_05.png
// module id = 313
// module chunks = 0